import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';
import { IMpxAllAssetsParams } from '../../../entity/interface/iMpxVodResponse';

export interface IGetMpxCastCrewUseCase {
    execute(byCredits: string): Promise<any>;
}

export class GetMpxCastCrewUseCase implements IGetMpxCastCrewUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(byCredits: string): Promise<any> {
        return this.mpxRepository.getMpxCastCrew(byCredits);
    }
}
